document.documentElement.classList.remove('no-js');

(() => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }

  const cursor = document.querySelector('.cursor-dot');
  if (cursor && window.matchMedia('(pointer:fine)').matches) {
    window.addEventListener('mousemove', (event) => {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
      cursor.classList.add('is-active');
    }, { passive: true });
    window.addEventListener('mouseleave', () => cursor.classList.remove('is-active'));
  }

  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const idInput = wrapper.querySelector('input[name="id"]');
    const button = wrapper.querySelector('[name="add"]');
    const price = document.querySelector(`[data-price-for="${wrapper.dataset.productForm}"]`);
    const variantsNode = wrapper.querySelector('[data-product-variants]');
    const optionGroups = [...wrapper.querySelectorAll('[data-option-position]')];
    if (!variantsNode || !optionGroups.length || !idInput) return;

    const variants = JSON.parse(variantsNode.textContent);
    const updateVariant = () => {
      const selectedOptions = optionGroups.map((group) => {
        const checked = group.querySelector('[data-option-value]:checked');
        const label = group.querySelector('[data-selected-option]');
        if (label && checked) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
      if (!variant) return;
      idInput.value = variant.id;
      if (price) {
        try {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: wrapper.dataset.currency || 'GBP' }).format(variant.price / 100);
        } catch (_) {}
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (history.replaceState && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    };
    optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
    updateVariant();
  });

  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    const form = builder.querySelector('[data-bundle-form]');
    if (!form) return;
    const readVariants = (name) => {
      const node = form.querySelector(`[data-bundle-${name}]`);
      return node ? JSON.parse(node.textContent) : [];
    };
    const products = { spacer: readVariants('spacer'), flask: readVariants('flask'), wordmark: readVariants('wordmark') };
    const touched = { spacer: false, topcap: false };
    const selected = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value;
    const matchingVariant = (variants, colour) => variants.find((variant) => variant.options.some((value) => value === colour));
    const update = () => {
      const spacerColour = selected('spacer-colour');
      const topcapColour = selected('topcap-colour');
      const style = selected('topcap-style');
      const spacerVariant = matchingVariant(products.spacer, spacerColour);
      const topcapVariant = matchingVariant(products[style], topcapColour);
      const spacerSummary = form.querySelector('[data-bundle-summary="spacer"]');
      const spacerBuySummary = form.querySelector('[data-bundle-summary="spacer-buy"]');
      const topcapSummaries = form.querySelectorAll('[data-bundle-summary="topcap"]');

      const button = form.querySelector('[data-bundle-submit]');
      if (spacerSummary) spacerSummary.textContent = `${spacerColour || '—'} spacer set`;
      if (spacerBuySummary) spacerBuySummary.textContent = `${spacerColour || '—'} spacers`;
      topcapSummaries.forEach((summary) => { summary.textContent = `${topcapColour || '—'} ${style === 'wordmark' ? 'V2' : 'V1'}`; });
      form.querySelectorAll('[data-slot-art]').forEach((art) => { art.hidden = art.dataset.slotArt !== style; });
      const steps = form.querySelectorAll('[data-flow-step]');
      steps.forEach((step) => step.classList.remove('is-active', 'is-complete'));
      if (!touched.spacer) steps[0]?.classList.add('is-active');
      else {
        steps[0]?.classList.add('is-complete');
        if (!touched.topcap) steps[1]?.classList.add('is-active');
        else {
          steps[1]?.classList.add('is-complete');
          steps[2]?.classList.add('is-active');
        }
      }
      const instruction = form.querySelector('[data-bundle-instruction]');
      if (instruction) instruction.textContent = !touched.spacer ? 'Choose your spacer colour — 2 items needed' : (!touched.topcap ? 'Spacer chosen — now choose your top cap' : 'Bundle ready — you save £1.99');
      if (button) {
        const available = spacerVariant?.available && topcapVariant?.available;
        button.disabled = !available;
        button.textContent = available ? 'Add the set to bag' : 'Selected option sold out';
      }
      return { spacerVariant, topcapVariant };
    };
    form.addEventListener('change', (event) => {
      if (event.target.name === 'spacer-colour') touched.spacer = true;
      if (event.target.name === 'topcap-style' || event.target.name === 'topcap-colour') touched.topcap = true;
      update();
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.querySelector('[data-bundle-status]');
      const button = form.querySelector('[data-bundle-submit]');
      const { spacerVariant, topcapVariant } = update();
      if (!spacerVariant?.available || !topcapVariant?.available) return;
      button.disabled = true;
      button.textContent = 'Adding set…';
      if (status) status.textContent = '';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: spacerVariant.id, quantity: 1 }, { id: topcapVariant.id, quantity: 1 }] }) });
        if (!response.ok) throw new Error('The selected set could not be added.');
        window.location.assign(`${root}cart`);
      } catch (error) {
        if (status) status.textContent = error.message || 'Please try again.';
        button.disabled = false;
        button.textContent = 'Add the set to bag';
      }
    });
    update();
  });

  const contactModal = document.querySelector('[data-contact-modal]');
  const contactOpeners = document.querySelectorAll('[data-contact-open]');
  let lastContactOpener = null;
  if (contactModal && contactOpeners.length) {
    const closeContact = () => {
      contactModal.hidden = true;
      document.body.classList.remove('contact-modal-open');
      lastContactOpener?.focus();
    };
    contactOpeners.forEach((contactOpen) => contactOpen.addEventListener('click', () => {
        lastContactOpener = contactOpen;
        contactModal.hidden = false;
        document.body.classList.add('contact-modal-open');
        contactModal.querySelector('input')?.focus();
      }));
    contactModal.querySelectorAll('[data-contact-close]').forEach((control) => control.addEventListener('click', closeContact));
    if (contactModal.querySelector('.contact-modal__success')) {
      contactModal.hidden = false;
      document.body.classList.add('contact-modal-open');
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !contactModal.hidden) closeContact();
    });
  }

  const cookiePreferences = document.querySelector('[data-cookie-preferences]');
  if (cookiePreferences) {
    if (window.Shopify?.customerPrivacy?.showPreferences) {
      cookiePreferences.addEventListener('click', () => window.Shopify.customerPrivacy.showPreferences());
    } else {
      cookiePreferences.hidden = true;
    }
  }
})();

;(() => {
  const colours=['Chrome','Orange','Red','Purple','Blue','Black'];
  const swatch=v=>'<span class="product-option__swatch product-option__swatch--'+v.toLowerCase()+'"></span><span>'+v+'</span>';
  const choices=(name,property=false)=>'<div class="tl-mix-choices">'+colours.map((v,i)=>'<label class="tl-mix-choice"><input type="radio" name="'+(property?'properties[Bolt colour]':name)+'" value="'+v+'" '+(i?'':'checked')+'>'+swatch(v)+'</label>').join('')+'</div>';
  document.querySelectorAll('[data-bundle-form]').forEach(form=>{
    if(!form.querySelector('[name="bolt-colour"]')){
      const field=document.createElement('fieldset'); field.className='bundle-choice-group tl-bolt-step'; field.innerHTML='<legend><span>04</span> Bolt colour</legend><p class="tl-mix-help">Mix and match it with your top cap.</p>'+choices('bolt-colour');
      form.querySelector('[data-choice-group="topcap"]')?.after(field);
    }
    let summary=form.querySelector('.tl-simple-summary');
    if(!summary){ summary=document.createElement('div'); summary.className='tl-simple-summary'; form.querySelector('.bundle-configurator__checkout')?.prepend(summary); }
    const selected=n=>form.querySelector('[name="'+n+'"]:checked')?.value;
    const update=()=>{ const style=selected('topcap-style')==='wordmark'?'V2':'V1'; summary.innerHTML='<small>Your set</small><strong>'+selected('spacer-colour')+' spacers · '+selected('topcap-colour')+' '+style+' cap · '+selected('bolt-colour')+' bolt</strong><span>Save £1.99 automatically in your bag.</span>'; };
    form.addEventListener('change',update); update();
    form.addEventListener('submit',async e=>{ e.preventDefault(); e.stopImmediatePropagation(); const read=n=>JSON.parse(form.querySelector('[data-bundle-'+n+']').textContent); const find=(a,c)=>a.find(v=>v.options.includes(c)); const style=selected('topcap-style'); const spacer=find(read('spacer'),selected('spacer-colour')); const cap=find(read(style),selected('topcap-colour')); const button=form.querySelector('[data-bundle-submit]'); const status=form.querySelector('[data-bundle-status]'); if(!spacer?.available||!cap?.available)return; button.disabled=true; button.textContent='Adding set…'; try{ const root=window.Shopify?.routes?.root||'/'; const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:spacer.id,quantity:1},{id:cap.id,quantity:1,properties:{'Bolt colour':selected('bolt-colour')}}]})}); if(!r.ok)throw Error('The selected set could not be added.'); location.assign(root+'cart'); }catch(err){ status.textContent=err.message; button.disabled=false; button.textContent='Add the set to bag'; } },true);
  });
  if(location.pathname.includes('/products/')) document.querySelectorAll('[data-product-form]').forEach(w=>{ const form=w.querySelector('form'); if(!form||form.querySelector('[name="properties[Bolt colour]"]')||!document.querySelector('.product-info__title')?.textContent.toLowerCase().includes('top cap'))return; const field=document.createElement('fieldset'); field.className='product-option product-option--bolt'; field.innerHTML='<legend class="product-form__label">Bolt colour <span data-bolt-label>Chrome</span></legend><p class="tl-mix-help">Choose any bolt colour to mix and match.</p>'+choices('',true); const qty=form.querySelector('label[for^="Quantity-"]'); qty?.before(field); field.addEventListener('change',()=>{field.querySelector('[data-bolt-label]').textContent=field.querySelector(':checked').value;}); });
  document.querySelector('.announcement__inner')?.childNodes.forEach(n=>{if(n.nodeType===3)n.textContent=n.textContent.replace('£75','£15')});
  if(!document.querySelector('.shipping-pop')){ const n=document.createElement('aside'); n.className='shipping-pop'; n.innerHTML='<button type="button" aria-label="Close">×</button><span>UK DELIVERY</span><strong>FREE SHIPPING</strong><small>ON ORDERS OVER £15</small>'; document.body.append(n); n.querySelector('button').onclick=()=>n.remove(); }
})();


// Trail Lab product gallery slider and variant-media sync.
(() => {
  const playGalleryVideos = () => {
    document.querySelectorAll('.gallery-hero video, .gallery-page video').forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const playback = video.play();
      if (playback?.catch) playback.catch(() => {});
    });
  };
  playGalleryVideos();
  window.addEventListener('pageshow', playGalleryVideos);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) playGalleryVideos();
  });
  document.addEventListener('touchstart', playGalleryVideos, { once: true, passive: true });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-product-media-index]')];
    const current = gallery.querySelector('[data-gallery-current]');
    if (!slides.length) return;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      if (current) current.textContent = String(activeIndex + 1);
    };
    gallery.dataset.galleryReady = 'true';
    gallery.showMedia = (mediaId) => {
      if (!mediaId) return;
      const index = slides.findIndex((slide) => String(slide.dataset.productMediaId) === String(mediaId));
      if (index >= 0) show(index);
    };
    const boltColoursIndex = slides.findIndex((slide) => {
      const image = slide.querySelector('img');
      const mediaReference = ((image?.currentSrc || image?.src || '') + ' ' + (image?.alt || '')).toLowerCase();
      return mediaReference.includes('codex-clipboard-706934cc-66cf-4702-9072-7ce51cc57308')
        || mediaReference.includes('all-colour-bolts')
        || mediaReference.includes('all-color-bolts')
        || mediaReference.includes('bolt-colours')
        || mediaReference.includes('bolt-colors');
    });
    gallery.showBoltColours = () => {
      if (boltColoursIndex >= 0) show(boltColoursIndex);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(activeIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(activeIndex + 1));
    show(activeIndex);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="properties[Bolt colour]"]')) {
      const gallery = event.target.closest('.product-layout')?.querySelector('[data-product-gallery]');
      if (event.target.checked) gallery?.showBoltColours?.();
      return;
    }
    if (!event.target.matches('[data-option-value]')) return;
    const wrapper = event.target.closest('[data-product-form]');
    if (!wrapper) return;
    const variantsNode = wrapper.querySelector('[data-product-variants]');
    const groups = [...wrapper.querySelectorAll('[data-option-position]')];
    if (!variantsNode || !groups.length) return;
    const selected = groups.map((group) => group.querySelector('[data-option-value]:checked')?.value || null);
    const variants = JSON.parse(variantsNode.textContent);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    const gallery = wrapper.closest('.product-layout')?.querySelector('[data-product-gallery]');
    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
    if (gallery?.showMedia && mediaId) gallery.showMedia(mediaId);
  });
})();


// Trail Lab free-shipping notice close action.
;(() => {
  const notice = document.querySelector('[data-shipping-pop]');
  if (!notice) return;

  try {
    if (sessionStorage.getItem('trail-lab-shipping-pop-closed') === '1') {
      notice.hidden = true;
    }
  } catch (_) {}

  notice.querySelector('[data-shipping-pop-close]')?.addEventListener('click', () => {
    notice.hidden = true;
    try {
      sessionStorage.setItem('trail-lab-shipping-pop-closed', '1');
    } catch (_) {}
  });
})();
